/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'edit-pen': {
    width: 13,
    height: 13,
    viewBox: '0 0 13 13',
    data: '<path pid="0" d="M0 10.5V13h2.5l7.373-7.374-2.5-2.5L0 10.5zm11.807-6.807c.26-.26.26-.68 0-.94l-1.56-1.56a.664.664 0 00-.94 0l-1.22 1.22 2.5 2.5 1.22-1.22z" _fill="#A8AAAF"/>'
  }
})
